import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EncrdecrService } from 'src/app/Auth/encrdecr.service';
import { CustomLoaderService } from 'src/app/services/custom-loader.service';
import { ProfileService } from 'src/app/services/profile.service';
import { RiskProfileService } from 'src/app/services/risk-profile.service';
import { TokenExpireService } from 'src/app/services/token-expire.service';
import { isNullOrUndefined } from 'src/app/validation';
declare var $: any;
@Component({
  selector: 'app-risk-profile-modal',
  templateUrl: './risk-profile-modal.component.html',
  styleUrls: ['./risk-profile-modal.component.scss']
})
export class RiskProfileModalComponent implements OnInit {
  @Output() FilterData: EventEmitter<any> = new EventEmitter();
  @Output() RiskProfileResponseMessage: EventEmitter<any> = new EventEmitter();
  @Input() ClientData: any;
  @Input() RiskProfileData: any;
  @Input() BindRiskProfileStatus: any;
  @Output() CheckTermsStatus: EventEmitter<any> = new EventEmitter();
  ShowDiv: boolean = true;
  showBtn: boolean = true;
  G_UserType: number;
  LoginID: string = "0";
  G_ClientBasicInfoId: string;
  ClientPAN: string;
  UserType: number = 0;
  EmpId: string = "0";
  SBId: string = "0";
  FilteredUserId: string;
  FilteredUserType: string;
  RiskProfileList: any = []
  RiskProfileForm: FormGroup;
  RiskProfileFormSubmitted: boolean = false;
  RiskProfileFormSaved: boolean = true;
  CheckIINTerms: boolean = false;
  selectedRiskProfile: any = null;
  isButtonSkipConfirmEnabled: boolean = false;
  Dynamic_ClientID: any;
  RiskProfileID: string;
  IsMobile: boolean = false;
  btnsaveconfirmdisabled: boolean = false;
  ShowSkipBtn: boolean = false;
  SB_EMP_ID: any = "";
  SB_EMP_RiskProfile: any = "";
  IsSB_EMP_RiskProfileDiv: boolean = false;
  RiskProfileName: string = "";
  SaveBtnText: any = "";
  constructor(private formBuilder: FormBuilder,
    private clientProfileService: ProfileService,
    private EncrdecrService: EncrdecrService,
    private Loader: CustomLoaderService,
    private Logout: TokenExpireService,
    private riskprofileservice: RiskProfileService,
    private router: Router,
    private bsModalRef: BsModalRef,
    private cdr: ChangeDetectorRef) {
    this.RiskProfileForm = formBuilder.group({
      RiskProfile: ["", Validators.required],
      // TAndC: ["", Validators.required]
      TAndC: [false]
    });
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.SetViewPort(event.target.innerWidth)
  }
  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    }
    else {
      this.IsMobile = false;
    }
  }
  ngOnInit(): void {
    debugger;
    this.SetViewPort(window.innerWidth);
    console.log("Current URL " + this.router.url);
    this.CheckTermsStatus.emit(this.CheckIINTerms);
    this.BindRiskProfileSkipBtnSettings();
    // console.log("Here RiskProfileData", this.RiskProfileData.RiskProfileId);
    if (sessionStorage.getItem("F44sGAGh2xwkpUL") != null && sessionStorage.getItem("F44sGAGh2xwkpUL") != undefined) {
      this.SB_EMP_ID = this.EncrdecrService.getDecr(sessionStorage.getItem("F44sGAGh2xwkpUL"));
    }
    if (sessionStorage.getItem("N1QJHdOkO7Hz8QC") != null && sessionStorage.getItem("N1QJHdOkO7Hz8QC") != undefined) {
      this.LoginID = this.EncrdecrService.getDecr(sessionStorage.getItem("N1QJHdOkO7Hz8QC"));
      if (sessionStorage.getItem("m5JkoXISmYRAIuY") != null && sessionStorage.getItem("m5JkoXISmYRAIuY") != undefined) {
        console.log("Here 1");
        this.Loader.show();
        this.BindRiskProfileList();
      }
      if (this.router.url == "/client-dashboard") {
        this.G_ClientBasicInfoId = this.LoginID;
      }
    }
    // else {
    //   if (sessionStorage.getItem("m5JkoXISmYRAIuY") != null && sessionStorage.getItem("m5JkoXISmYRAIuY") != undefined) {
    //     console.log("Here 2");
    //     this.Loader.show();
    //     setTimeout(() => {
    //       this.BindRiskProfileList();
    //     }, 3000); // 3-second delay (3000ms)
    //   }
    // }
    if (this.router.url.includes('risk-profile-verify?')) {
      this.ShowDiv = false;
      this.G_UserType = 3;
      this.Loader.show();
      this.RiskProfileForm.controls['RiskProfile'].setValue(this.RiskProfileData.RiskProfileId);
      if (sessionStorage.getItem("m5JkoXISmYRAIuY") != null && sessionStorage.getItem("m5JkoXISmYRAIuY") != undefined) {
        setTimeout(() => {
          this.BindRiskProfileList();
        }, 3000); // 3-second delay (3000ms)
      }
    }
    if (this.router.url == "/client-dashboard") {
      this.isButtonSkipConfirmEnabled = true;
      this.G_UserType = 3;
      this.BindRiskProfileList();
    }
    //debugger
    if (sessionStorage.getItem("L2D3506kIHSk3E0") != null && sessionStorage.getItem("L2D3506kIHSk3E0") != undefined) {
      this.G_UserType = parseInt(this.EncrdecrService.getDecr(sessionStorage.getItem("L2D3506kIHSk3E0")));
    }

    this.SaveBtnText = this.G_UserType == 3 ? "Save" : "Send Link"

    if (this.router.url == "/transaction-new-latest/lumpsum" || this.router.url == "/transaction-new-latest/sip" || this.router.url == "/transaction-new-latest/switch" || this.router.url == "/transaction-new-latest/stp") {
      this.isButtonSkipConfirmEnabled = true;
      this.Dynamic_ClientID = this.EncrdecrService.getDecr(sessionStorage.getItem("Ji7+req4XkCAakmVheaD7g==")); //ClientID selected from Dropdown investor
      if (!isNullOrUndefined(this.Dynamic_ClientID) && this.Dynamic_ClientID != '') {
        this.showBtn = false;
      } else {
        this.showBtn = true;
      }
      if (sessionStorage.getItem("m5JkoXISmYRAIuY") != null && sessionStorage.getItem("m5JkoXISmYRAIuY") != undefined) {
        console.log("here 3");
        setTimeout(() => {
          this.BindRiskProfileList();
        }, 1000); // 3-second delay (3000ms)
      }
    }
    if (this.router.url == "/client-dashboard") {
      this.G_ClientBasicInfoId = this.LoginID;
    }

    this.applyConditionalValidation();
    if (this.BindRiskProfileStatus == true) {
      this.Loader.show();
      console.log("In");
      this.BindRiskProfileList();
    }
    if (sessionStorage.getItem("m5JkoXISmYRAIuY") != null && sessionStorage.getItem("m5JkoXISmYRAIuY") != undefined) {
      console.log("for");
      this.Loader.show();
      this.BindRiskProfileList();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    //debugger
    // console.log("ClientData From Filter: " + JSON.stringify(this.ClientData));
    // this.G_ClientBasicInfoId = this.ClientData.ClientBasicInfoId;

    console.log("Here ngOnChanges ");
    if (this.router.url.includes('risk-profile-verify?')) {
      this.G_UserType = 3;
      this.Loader.show();
      this.RiskProfileForm.controls['RiskProfile'].setValue(this.RiskProfileData.RiskProfileId);
      if (sessionStorage.getItem("m5JkoXISmYRAIuY") != null && sessionStorage.getItem("m5JkoXISmYRAIuY") != undefined) {
        setTimeout(() => {
          this.BindRiskProfileList();
        }, 3000);
      }
    }
    debugger
    if (this.G_UserType == 2 || this.G_UserType == 1) {
      this.getClientRiskProfile(this.ClientData.ClientBasicInfoId);
      if (!isNullOrUndefined(this.ClientData.ClientBasicInfoId) && this.ClientData.ClientBasicInfoId != '') {
        this.showBtn = false;
      } else {
        this.showBtn = true;
      }
      console.log("Show btn", this.showBtn);
    } else if (this.G_UserType == 3) {
      debugger
      this.getClientRiskProfile(this.ClientData.ClientBasicInfoId);
    }


  }
  get RP() {
    return this.RiskProfileForm.controls;
  }
  getClientRiskProfile(client_id) {
    this.Loader.show();
    let date = new Date();
    let rid = date.getFullYear().toString() + date.getMonth().toString() + date.getDate().toString() + date.getHours().toString() + date.getMinutes().toString() + date.getSeconds().toString() + date.getMilliseconds().toString() + client_id;
    let TempDataBody = {
      ClientbasicinfoId: client_id,
      InsertedBy: this.SB_EMP_ID,
      rid: rid,
      jid: this.EncrdecrService.setEncr(sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX')),
      UserType: this.G_UserType,
      initiatedBy: this.SB_EMP_ID,
      Trans_Type: "GetClientRiskProfile"
    };
    let DataBody = JSON.stringify(TempDataBody);

    this.riskprofileservice
      .GetClientRiskProfile(DataBody)
      .subscribe((response: any) => {

        // let result = JSON.parse(this.EncrdecrService.getDecr(response));

        if (response != null) {
          if (
            response.Message != null &&
            response.Message != "" &&
            response.Message.indexOf("Not Authorized") > -1
          ) {
            this.Loader.hide();
            this.Logout.LogoutUser();
            return;
          }
          else {
            console.warn("Client Risk Profile : ", response);

            if (response.code == 200 && !isNullOrUndefined(response.ArrayOfResponse)) {
              debugger;
              this.RiskProfileID = response.ArrayOfResponse[0].RiskProfileId
              this.RiskProfileForm.controls['RiskProfile'].setValue(response.ArrayOfResponse[0].RiskProfileId.toString());
              this.SB_EMP_RiskProfile = response.ArrayOfResponse[0].SB_EMP_RiskProfile.toString();
              if (this.SB_EMP_RiskProfile != '') {
                if (this.SB_EMP_RiskProfile == this.RiskProfileName) {
                  this.IsSB_EMP_RiskProfileDiv = false;
                }
                else {
                  this.IsSB_EMP_RiskProfileDiv = true;
                }
              }
              this.Loader.hide();
            }
          }
        }
      });
  }
  applyConditionalValidation() {
    const tAndCControl = this.RiskProfileForm.get('TAndC');

    if (this.G_UserType == 3) {
      // Set validator for specific user type
      tAndCControl.setValidators([Validators.requiredTrue]);
      if (sessionStorage.getItem("aaIHl0pIiYe71gyyxC/5xA==") != null && sessionStorage.getItem("aaIHl0pIiYe71gyyxC/5xA==") != undefined) {
        let RiskProfileStatus = this.EncrdecrService.getDecr(sessionStorage.getItem('aaIHl0pIiYe71gyyxC/5xA=='));
        if (RiskProfileStatus == 'Expired' || RiskProfileStatus == 'Pending') {
          if (sessionStorage.getItem("F3IuZBKaCEi4EdKlAkyGPA==") != null && sessionStorage.getItem("F3IuZBKaCEi4EdKlAkyGPA==") != undefined) {
            this.RiskProfileID = this.EncrdecrService.getDecr(sessionStorage.getItem("F3IuZBKaCEi4EdKlAkyGPA==")).toString();
            this.RiskProfileForm.controls['RiskProfile'].setValue(this.RiskProfileID);
            this.SB_EMP_RiskProfile = this.EncrdecrService.getDecr(sessionStorage.getItem("GuLf4EgIAkOTmdbf9e8/XA==")).toString();
            this.RiskProfileName = this.EncrdecrService.getDecr(sessionStorage.getItem("AqVk7klfa+b0nlVjO8Y90I=")).toString();
            if (this.SB_EMP_RiskProfile != '') {
              if (this.SB_EMP_RiskProfile == this.RiskProfileName) {
                this.IsSB_EMP_RiskProfileDiv = false;
              }
              else {
                this.IsSB_EMP_RiskProfileDiv = true;
              }
            }
          }
        }
      }
    } else {
      // Clear validators if condition is not met
      tAndCControl.clearValidators();
    }
    // MANDATORY: Recalculate validity status
    tAndCControl.updateValueAndValidity();
  }
  ngAfterViewInit() {
    $("select").select2();
    $(".CustomeselectRiskProfile").on("change", (e: any) => this.RiskProfileForm.controls["RiskProfile"].setValue(e.target.value));
    console.log("Here ngAfterViewInit ");

  }
  BindRiskProfileList() {
    debugger
    this.clientProfileService.GetRiskProfileDetails("GetRiskProfileList", '').subscribe((data_res) => {
      let res_str = this.EncrdecrService.getDecr(data_res);
      let data = JSON.parse(res_str);
      if (data.ArrayOfResponse.length > 0) {
        this.RiskProfileList = data.ArrayOfResponse;
        this.Loader.hide();
        console.log("tRisk Profile List", this.RiskProfileList);
      }
    })
  }
  BindRiskProfileSkipBtnSettings() {
    debugger
    this.clientProfileService.GetRiskProfileDetails("GetRiskProfileSkipButtonSettings", '').subscribe((data_res) => {
      let res_str = this.EncrdecrService.getDecr(data_res);
      let data = JSON.parse(res_str);
      if (data.ArrayOfResponse.length > 0) {
        console.log("Skip button", data.ArrayOfResponse);
        let skipBtn = data.ArrayOfResponse[0].TEXTFIELD;
        if (skipBtn == "No") {
          this.ShowSkipBtn = true;
        }
        // this.RiskProfileList = data.ArrayOfResponse;
        this.Loader.hide();
      }
    })
  }
  // onCheck(value: any) {
  //   console.log("Selected Value:", value);
  //   this.FilterData.emit(value);
  //   // Perform custom logic here
  // }

  onSubmitRiskProfile() {
    if (this.router.url.includes('risk-profile-verify?')) {
      this.RiskProfileFormSubmitted = true
      this.RiskProfileForm.enable()
      if (this.RiskProfileForm.invalid) {
        return;
      }
      else {
        this.Loader.show()
        let Pan = this.ClientPAN;

        //debugger
        let date = new Date();
        let rid = date.getFullYear().toString() + date.getMonth().toString() + date.getDate().toString() + date.getHours().toString() + date.getMinutes().toString() + date.getSeconds().toString() + date.getMilliseconds().toString() + this.G_ClientBasicInfoId;

        let TempDataBody = {
          ClientbasicinfoId: this.LoginID,
          RiskProfileID: this.RiskProfileForm.controls["RiskProfile"].value,
          // UccCode: this.G_U,
          InsertedBy: this.LoginID,
          rid: rid,
          jid: this.EncrdecrService.setEncr(sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX')),
          UserType: this.G_UserType,
          initiatedBy: this.LoginID,
          Trans_Type: "ClientApprove",
          IPAddress: sessionStorage.getItem('Tgsh@#3734fjfskshh==')
        };
        let DataBody = JSON.stringify(TempDataBody);

        this.riskprofileservice
          .InsertDetails(DataBody)
          .subscribe((response: any) => {

            // let result = JSON.parse(this.EncrdecrService.getDecr(response));
            if (response != null) {
              if (
                response.Message != null &&
                response.Message != "" &&
                response.Message.indexOf("Not Authorized") > -1
              ) {
                this.Loader.hide();
                this.Logout.LogoutUser();
                return;
              }
              else {
                this.Loader.hide()
                this.CallAlertModal(response.Message);
                this.RiskProfileResponseMessage.emit(response.Message);
                // this.RiskProfileForm.reset();
              }
            }
            else {
              this.Loader.hide();
              this.CallAlertModal("Something went wrong!");
            }
          })
      }
    } else {
      debugger
      this.RiskProfileFormSubmitted = true
      this.RiskProfileForm.enable()
      if (this.RiskProfileForm.invalid) {
        return;
      }
      else {
        this.Loader.show()
        let Pan = this.ClientPAN;

        //debugger
        let date = new Date();
        let rid = date.getFullYear().toString() + date.getMonth().toString() + date.getDate().toString() + date.getHours().toString() + date.getMinutes().toString() + date.getSeconds().toString() + date.getMilliseconds().toString() + this.LoginID;
        if (this.router.url == "/transaction-new-latest/lumpsum" || this.router.url == "/transaction-new-latest/sip" || this.router.url == "/transaction-new-latest/switch" || this.router.url == "/transaction-new-latest/stp") {
          this.Dynamic_ClientID = this.EncrdecrService.getDecr(sessionStorage.getItem("Ji7+req4XkCAakmVheaD7g==")); //ClientID selected from Dropdown investor
        } else {
          this.Dynamic_ClientID = this.G_UserType == 3 ? this.LoginID : this.ClientData.ClientBasicInfoId
        }
        let TempDataBody = {
          ClientbasicinfoId: this.Dynamic_ClientID,
          RiskProfileID: this.RiskProfileForm.controls["RiskProfile"].value,
          // UccCode: this.G_U,
          InsertedBy: this.Dynamic_ClientID,
          rid: rid,
          jid: this.EncrdecrService.setEncr(sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX')),
          UserType: this.G_UserType,
          initiatedBy: this.G_UserType == 3 ? this.Dynamic_ClientID : this.SB_EMP_ID,
          Trans_Type: this.G_UserType == 3 ? "ClientRiskProfile" : "RMSBRequestRiskProfile",
          IPAddress: sessionStorage.getItem('Tgsh@#3734fjfskshh==')
        };
        let DataBody = JSON.stringify(TempDataBody);

        this.riskprofileservice
          .InsertDetails(DataBody)
          .subscribe((response: any) => {

            // let result = JSON.parse(this.EncrdecrService.getDecr(response));

            if (response != null) {
              if (
                response.Message != null &&
                response.Message != "" &&
                response.Message.indexOf("Not Authorized") > -1
              ) {
                this.Loader.hide();
                this.Logout.LogoutUser();
                return;
              }
              else {
                if (response.code == 200) {
                  if (this.G_UserType == 3) {
                    this.Loader.hide()
                    this.RiskProfileResponseMessage.emit("Risk Profile Updated Successful");
                    this.CallAlertModal("Risk Profile Updated Successful.")
                  } else {
                    this.Loader.hide()
                    this.RiskProfileResponseMessage.emit("Link has been sent to client.");
                    this.CallAlertModal("Link has been sent to client.")
                  }
                }
                else {
                  this.Loader.hide()
                  this.CallAlertModal(response.Message);
                }
              }
            }
            else {
              this.Loader.hide();
              this.CallAlertModal("Something went wrong!");
            }
          })
      }
    }
  }
  CallAlertModal(msg: any) {
    $("#AlertModal").modal({
      backdrop: "static",
      keyboard: false,
    });
    $("#AlertModalContent").text(msg);
  }
  isNullOrUndefined(object: unknown) {
    let val: boolean = false;
    if (object == null || object == undefined) {
      val = true;
    }
    return val;
  }

  CheckTerms(e) {
    if (e.target.checked) {
      this.CheckIINTerms = true;
    }
    else {
      this.CheckIINTerms = false;
    }
    // this.CheckTermsStatus.emit(this.CheckIINTerms);
  }

  CallTermsAndConditionsModal() {
    $('#TermsAndConditionsModal').modal({
      backdrop: 'static',
      keyboard: false
    });
    // $('#TermsAndConditionsModalContent').text();
  }
  RefreshPage() {
    if (this.router.url.includes('risk-profile-verify?')) {
      this.Logout.LogoutUser();
    }
    else {
      window.location.reload();
    }
  }
  onSkipRiskProfile() {
    if (this.G_UserType == 3 && this.router.url == '/client-dashboard') { //if client and on dashboard then close the popup
      this.bsModalRef.hide();
    }
    else if (this.G_UserType == 3 && this.router.url != '/client-dashboard') { //if client and on transaction pages then close the popup and go to dashboard
      this.bsModalRef.hide();
      window.location.href = '/client-dashboard';
    }
    else if (this.G_UserType != 3 && this.router.url != '/client-dashboard') { //if SB/RM and on transaction pages then close popup only
      this.bsModalRef.hide();
    }
  }

}
